<template>
  <div class="blog-details-area ptb-100">
    <div class="container mw-1356" v-if="blog">
      <div class="row">
        <div class="col-lg-9 order-2 order-lg-1">
          <div class="blog-details-img mb-4">
            <img :src="blog.image" :alt="blog.title" class="w-100" />
          </div>

          <h2 class="mb-4">{{ blog.title }}</h2>

          <ul class="nav nav-tabs description-tabs">
            <li class="nav-item">
              <button
                class="nav-link"
                :class="{ active: activeTab === 'description' }"
                @click="activeTab = 'description'"
              >
                الوصف
              </button>
            </li>
            <li class="nav-item">
              <button
                class="nav-link"
                :class="{ active: activeTab === 'reviews' }"
                @click="activeTab = 'reviews'"
              >
                المراجعات
              </button>
            </li>
          </ul>

          <div class="tab-content">
            <div v-show="activeTab === 'description'" class="pt-4">
              <div class="blog-details-content" v-html="blog.content"></div>
            </div>

            <div v-show="activeTab === 'reviews'" class="pt-4">
              <div class="blog-details-content">
                <h3>المراجعات</h3>
                <p>شاركنا رأيك حول هذه المقالة في التعليقات أدناه.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3 order-1 order-lg-2 mb-5 mb-lg-0">
          <SidebarWidget />
        </div>
      </div>
    </div>

    <div class="container mw-1356" v-else>
      <div class="text-center ptb-100">
        <h2>المقال غير موجود</h2>
        <p>عذرًا، لم نتمكن من العثور على المقال المطلوب.</p>
        <RouterLink to="/blog" class="btn btn-primary">
          العودة إلى المدونة
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import { useRoute } from "vue-router";
import { useHead } from "@unhead/vue";
import SidebarWidget from "../Blog/SidebarWidget.vue";

export default defineComponent({
  name: "BlogDetails",
  components: { SidebarWidget },
  setup() {
    const route = useRoute();
    const activeTab = ref("description");

    const allBlogs = [
      {
        id: 1,
        image: require("@/assets/images/blog-4.jpg"),
        title: "كيف تضبط إعدادات سيرفر الـ IPTV للحصول على أعلى ثبات؟",
        seoTitle: "ضبط إعدادات IPTV لأعلى ثبات | دليل تقليل التقطيع",
        seoDescription:
          "تعرف على أفضل إعدادات IPTV لتقليل التقطيع وتحسين ثبات البث، مع نصائح حول الاتصال السلكي، إعداد Buffer، وتحديث روابط M3U.",
        keywords:
          "إعدادات IPTV, تقليل التقطيع, ثبات IPTV, Buffer IPTV, M3U, سيرفر IPTV",
        content:
          "<h3>مقدمة</h3><p>يعتمد استقرار خدمة IPTV بشكل كبير على إعدادات المشغل ونوع الاتصال. في هذا المقال، سنوضح لك أهم الخطوات لتقليل التقطيع.</p><h3>خطوات الضبط</h3><ul><li>استخدام اتصال سلكي (Ethernet) بدلاً من الواي فاي.</li><li>ضبط خيار الـ Buffer في التطبيق على 5-10 ثوانٍ.</li><li>تحديث عنوان الـ M3U بشكل دوري.</li></ul>",
      },
      {
        id: 2,
        image: require("@/assets/images/blog-2.jpg"),
        title: "أفضل مشغلات IPTV لأجهزة أندرويد وشاشات سمارت",
        seoTitle: "أفضل مشغلات IPTV لأندرويد وشاشات Smart TV",
        seoDescription:
          "اكتشف أفضل تطبيقات تشغيل IPTV على أجهزة أندرويد وشاشات Smart TV مثل IPTV Smarters وTivimate وXCIPTV.",
        keywords:
          "أفضل مشغل IPTV, IPTV Smarters, Tivimate, XCIPTV, Android TV, Smart TV",
        content:
          "<h3>لماذا اختيار المشغل مهم؟</h3><p>تختلف تطبيقات المشغلات في دعمها للكودك (Codecs) وسرعة تحميل القنوات. نوصي دائماً باستخدام التطبيقات الأكثر استقراراً لضمان تجربة مشاهدة سلسة.</p><h3>أبرز التطبيقات:</h3><ol><li>IPTV Smarters Pro</li><li>Tivimate</li><li>XCIPTV</li></ol>",
      },
      {
        id: 3,
        image: require("@/assets/images/blog-3.jpg"),
        title: "دليلك الشامل لتركيب Fire TV Stick مع اشتراكك",
        seoTitle: "طريقة تشغيل IPTV على Fire TV Stick خطوة بخطوة",
        seoDescription:
          "دليل مبسط لتثبيت تطبيق IPTV على Fire TV Stick وتشغيل الاشتراك باستخدام Downloader وبيانات التفعيل.",
        keywords:
          "Fire TV Stick IPTV, تشغيل IPTV على فاير ستيك, Downloader, تطبيق IPTV, شرح IPTV",
        content:
          "<h3>تركيب سهل في دقائق</h3><p>يعتبر Fire Stick أحد أفضل الأجهزة لتشغيل IPTV. إليك كيفية البدء:</p><ul><li>قم بتحميل تطبيق Downloader.</li><li>أدخل الرابط الخاص بتطبيق المشغل.</li><li>قم بتسجيل الدخول ببيانات اشتراكك المرسلة إليك.</li></ul>",
      },
      {
        id: 4,
        image: require("@/assets/images/blog-5.jpg"),
        title: "لماذا يفضل المحترفون اشتراكات IPTV الخاصة بنا؟",
        seoTitle: "لماذا يفضل المستخدمون اشتراكات IPTV المستقرة؟",
        seoDescription:
          "تعرف على أسباب تفضيل المستخدمين لاشتراكات IPTV المستقرة، مثل قوة السيرفرات، سرعة التفعيل، وجودة القنوات.",
        keywords:
          "اشتراكات IPTV مستقرة, أفضل IPTV, سيرفرات IPTV, جودة IPTV, قنوات IPTV",
        content:
          "<p>نحن نستخدم سيرفرات عالية الأداء موزعة عالمياً لضمان عدم وجود ضغط على أي سيرفر بعينه، مما يضمن ثبات القنوات طوال الوقت.</p>",
      },
      {
        id: 5,
        image: require("@/assets/images/blog-6.jpg"),
        title: "حل مشاكل التقطيع أثناء مباريات كرة القدم المباشرة",
        seoTitle: "حل مشكلة تقطيع IPTV أثناء المباريات المباشرة",
        seoDescription:
          "تعرف على أسباب تقطيع IPTV أثناء مباريات كرة القدم المباشرة وأفضل الحلول لتحسين الاستقرار وتقليل التوقف.",
        keywords:
          "تقطيع IPTV, مباريات مباشرة IPTV, حل تقطيع القنوات, كرة قدم IPTV, بث مباشر",
        content:
          "<p>في أوقات الضغط العالي (أثناء المباريات)، قد تواجه تقطيعاً بسيطاً. جرب دائماً تغيير جودة البث من FHD إلى HD لتقليل استهلاك النطاق الترددي.</p>",
      },
      {
        id: 6,
        image: require("@/assets/images/blog-7.jpg"),
        title: "فهم جودة 4K و الفرق بينها وبين Full HD في البث",
        seoTitle: "الفرق بين جودة 4K وFull HD في IPTV",
        seoDescription:
          "شرح مبسط للفرق بين جودة 4K وFull HD في خدمات IPTV ومتطلبات الإنترنت والجهاز للحصول على أفضل تجربة مشاهدة.",
        keywords:
          "IPTV 4K, Full HD IPTV, جودة البث, الفرق بين 4K وHD, قنوات 4K",
        content:
          "<p>بث 4K يتطلب سرعة إنترنت لا تقل عن 25 ميجابت/ثانية. تأكد من أن جهازك يدعم فك تشفير 4K قبل تفعيل هذا الخيار في القنوات.</p>",
      },
      {
        id: 7,
        image: require("@/assets/images/blog-8.jpg"),
        title: "كيف تحمي خصوصيتك عند استخدام خدمات البث",
        seoTitle: "نصائح لحماية الخصوصية عند استخدام خدمات البث وIPTV",
        seoDescription:
          "تعرف على أهم النصائح لحماية خصوصيتك أثناء استخدام خدمات البث وIPTV، مثل اختيار اتصال آمن وتحديث التطبيقات.",
        keywords:
          "خصوصية IPTV, حماية الخصوصية, خدمات البث, أمان الإنترنت, VPN IPTV",
        content:
          "<p>استخدام VPN موثوق يساعدك على تجاوز قيود مزودي الإنترنت (ISP) التي قد تؤثر على سرعة خدمات البث التي تستخدمها.</p>",
      },
      {
        id: 8,
        image: require("@/assets/images/blog-9.jpg"),
        title: "خطوات تفعيل اشتراكك في أقل من دقيقة",
        seoTitle: "طريقة تفعيل اشتراك IPTV بسرعة على جهازك",
        seoDescription:
          "شرح سريع لطريقة تفعيل اشتراك IPTV باستخدام بيانات Xtream Codes أو رابط M3U على مختلف الأجهزة.",
        keywords:
          "تفعيل IPTV, طريقة تشغيل IPTV, Xtream Codes, M3U, اشتراك IPTV",
        content:
          "<p>بمجرد حصولك على كود التفعيل أو بيانات الـ M3U، أدخلها في خانة 'Login with Xtream Codes API' لتحميل القنوات تلقائياً.</p>",
      },
      {
        id: 9,
        image: require("@/assets/images/blog-10.jpg"),
        title: "أهم الميزات المخفية في تطبيق IPTV الخاص بنا",
        seoTitle: "ميزات مفيدة في تطبيقات IPTV قد لا تعرفها",
        seoDescription:
          "اكتشف ميزات مفيدة في تطبيقات IPTV مثل المفضلة، البحث، ترتيب القنوات، المشاهدة المتعددة، والتحكم بجودة البث.",
        keywords:
          "ميزات IPTV, تطبيق IPTV, مفضلة القنوات, Multi Screen IPTV, ترتيب القنوات",
        content:
          "<p>هل جربت ميزة 'Multi-Screen'؟ تتيح لك مشاهدة 4 قنوات في وقت واحد على نفس الشاشة! يمكنك الوصول إليها من القائمة الجانبية.</p>",
      },
    ];

    const blog = computed(() => {
      return allBlogs.find((b) => b.id === Number(route.params.id));
    });

    useHead(() => {
      const currentBlog = blog.value;

      return {
        title: currentBlog?.seoTitle || "المقال غير موجود | Karam TV 4K",
        meta: [
          {
            name: "description",
            content:
              currentBlog?.seoDescription ||
              "عذرًا، لم نتمكن من العثور على المقال المطلوب.",
          },
          {
            name: "keywords",
            content:
              currentBlog?.keywords ||
              "IPTV, مقالات IPTV, شروحات IPTV, قنوات عربية",
          },
          {
            property: "og:title",
            content: currentBlog?.seoTitle || "المقال غير موجود",
          },
          {
            property: "og:description",
            content:
              currentBlog?.seoDescription ||
              "عذرًا، لم نتمكن من العثور على المقال المطلوب.",
          },
          {
            property: "og:type",
            content: "article",
          },
          {
            name: "robots",
            content: currentBlog ? "index, follow" : "noindex, follow",
          },
        ],
        link: [
          {
            rel: "canonical",
            href: currentBlog
              ? `https://karamtv4k.com/blog-details/${currentBlog.id}`
              : "https://karamtv4k.com/blog",
          },
        ],
      };
    });

    return { activeTab, blog };
  },
});
</script>